import { ToastProgrammatic as Toast } from 'buefy';
import { cloneDeep } from 'lodash';
import { mapActions, mapState } from 'vuex';

import {
  GET_STORE_LIST,
  DELETE_STORE,
} from '@/store/store/constants';
import { DEFAULT_PER_PAGE, FIRST_PAGE, PER_PAGE_OPTIONS } from '@/utils/constants';
import weekdayTransformer from '@/utils/weekdayTransformer';

export default {
  name: 'StoreList',
  data() {
    return {
      page: FIRST_PAGE,
      perPage: DEFAULT_PER_PAGE,
      search: '',
      loading: false,
      columns: [
        {
          column: 'index',
          name: 'No.',
          visible: true,
        },
        {
          column: 'tag',
          name: '店家標籤',
          visible: true,
        },
        {
          column: 'closed_day',
          name: '公休日',
          visible: true,
        },
        {
          column: 'address',
          name: '地址',
          visible: true,
        },
        {
          column: 'note',
          name: '備註',
          visible: true,
        },
      ],
      stores: [],
      storeToRemove: null,
      showConfirmation: false,
    };
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  async created() {
    await this.loadStoreList();
  },
  computed: {
    ...mapState('store', ['storesInfos']),
    allStores() {
      return this.storesInfos?.stores || [];
    },
    filteredStoreList() {
      return this.stores.filter((store) => store.store_detail.name.includes(this.search));
    },
    columnVisibility() {
      const mapping = {};

      this.columns.forEach((c) => {
        mapping[c.column] = c.visible;
      });
      return mapping;
    },
    perPageOptions() {
      return PER_PAGE_OPTIONS;
    },
    total() {
      return this.storesInfos?.pagination?.total || 0;
    },
  },
  watch: {
    allStores: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.stores = cloneDeep(newVal);
        }
      },
    },
    page() {
      this.loadStoreList();
    },
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setPageOrGetData();
      }
    },
  },
  methods: {
    ...mapActions('store', {
      getStoreList: GET_STORE_LIST,
      deleteStore: DELETE_STORE,
    }),
    columnThAttrs() {
      return {
        class: 'text-xs',
      };
    },
    async loadStoreList() {
      try {
        this.loading = true;
        await this.getStoreList({ page: this.page, perPage: this.perPage });
      } catch (e) {
        Toast.open({
          type: 'is-danger',
          message: e.message || '發生錯誤，請重試一次',
        });
      } finally {
        this.loading = false;
      }
    },
    transformClosedDay(closedDay) {
      return weekdayTransformer(closedDay.map((d) => d.day));
    },
    editStore(store) {
      this.$router.push(`/store/${store.id}/edit`);
    },
    onRemoveStore(storeId) {
      this.storeToRemove = storeId;
      this.showConfirmation = true;
    },
    async removeStore() {
      try {
        if (!this.storeToRemove) {
          return;
        }
        this.loading = true;
        await this.deleteStore(this.storeToRemove);
        this.stores = [];
        await this.loadStoreList();
        this.showConfirmation = false;
        Toast.open({
          type: 'is-warning',
          message: '刪除成功',
        });
      } catch (ex) {
        const message = ex?.message ? `(${ex.message})` : '';

        Toast.open({
          type: 'is-danger',
          message: `發生錯誤，請重試一次${message}`,
        });
      } finally {
        this.loading = false;
      }
    },
    setPageOrGetData() {
      this.stores = [];
      if (this.page !== FIRST_PAGE) {
        this.page = FIRST_PAGE;
      } else {
        this.loadStoreList();
      }
    },
  },
};
